import script from "./StatsCardsComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./StatsCardsComponent.vue?vue&type=script&setup=true&lang=js"

import "./StatsCardsComponent.vue?vue&type=style&index=0&id=b2ba503a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b2ba503a"]])

export default __exports__